import EnrollmentDetail from "../../admin/enrollments/EnrollmentDetail";

export default function ManagerEnrollmentDetail() {
    return <EnrollmentDetail role="MANAGER" />;
}
